import React from "react";
import { provideImageOrdersExcludedCurrentFormat, providePriceForFormat, } from "../../../../server/sharedScripts/priceProviderInterpreter.js";
import "./orderedImageRow.css";
export default function OrderedImageRow(props) {
    var _a;
    const { order } = props;
    return (React.createElement("tr", null,
        React.createElement("td", null, order.imageName),
        React.createElement("td", null, order.offerName),
        props.areResources && React.createElement("td", null, (_a = order.selectedCustomization) !== null && _a !== void 0 ? _a : "brak"),
        React.createElement("td", null,
            order.orderedFormats.map((format, index) => (React.createElement("div", { key: index },
                format.name,
                ": ",
                format.count,
                " szt."))),
            order.orderedElectronicFile && "Wersja elektroniczna: Tak"),
        React.createElement("td", null,
            order.orderedFormats.reduce((acc, format) => acc +
                providePriceForFormat(format.pricePerItem, {
                    currentFormatName: format.name,
                    orderedFormats: order.orderedFormats,
                    quantity: format.count,
                    imageOrdersExcludedCurrentFormat: provideImageOrdersExcludedCurrentFormat(props.orders, order.imageIndex, order.offerIndex, format.name),
                }), 0) +
                (order.orderedElectronicFile ? order.pricePerElectronicFile : 0),
            " ",
            "z\u0142")));
}
